module.exports = "/images/ico-comm-v.png?acca971dd8e82daaaa4ac0857ba296bb";


//////////////////
// WEBPACK FOOTER
// ./resources/images/project-img/ico-comm-v.png
// module id = fErB
// module chunks = 1